interface KeyValueCardProps {
  label: string;
  value: string | React.ReactNode;
}

export const KeyValueCard = ({ label, value }: KeyValueCardProps) => {
  return (
    <div className="bg-brand-cardBgVariant1 p-3 border-l-4 border-l-brand-primaryAction rounded-md">
      <h4 className="text-brand-secondaryTextLabelGrey text-xs">{label}</h4>
      <h3 className="text-brand-primaryTextDarkGrey text-sm">{value}</h3>
    </div>
  );
};
